import React from 'react';

// Styles & Assets
import styles from './ToolbarPatientsSelector.module.css';
import { RiFilterFill } from 'react-icons/ri';
import { MdEdit } from 'react-icons/md';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Hooks
import { useContext } from 'react';
import useFilteredPatients from '../../../hooks/useFilteredPatients';
import { useTranslation } from 'react-i18next';

// Components
import ButtonToolbar from '../../UI/ButtonToolbar/ButtonToolbar';
import NavbarWrapper from '../../UI/NavbarWrapper/NavbarWrapper';
import Searchbar from '../../UI/Searchbar/Searchbar';
import SliderCheckbox from '../../UI/SliderCheckbox/SliderCheckbox';
import FilterDialog from '../../PatientsPage/FilterDialog/FilterDialog';
import EditColumnsDialog from '../../PatientsPage/EditColumnsDialog/EditColumnsDialog';

// Interfaces 
interface Props {
    viewSonar: boolean
    changeViewSonar: (evt: React.ChangeEvent<HTMLInputElement>) => void
}


const ToolbarPatientsSelector: React.FC<Props> = ({ viewSonar, changeViewSonar }) => {

    const { t } = useTranslation();

    const { patientFilters: { currentSearchbarText } } = useContext(FiltersContext);

    const { filtersActive, handleChangeSearchbar } = useFilteredPatients();

    return (
        <NavbarWrapper>
            <div className={styles.patientsToolbarContainer}>
                <div className={styles.columnsToolbar}>
                    <SliderCheckbox
                        handleChange={changeViewSonar}
                        label={t('sonar_view')}
                    />
                </div>
                <div className={styles.columnsToolbar}>
                    <Searchbar
                        handleChange={handleChangeSearchbar}
                        defaultValue={currentSearchbarText}
                    />
                    <ButtonToolbar
                        icon={<RiFilterFill />}
                        label={t('filter')}
                        defaultFilterActive={filtersActive}
                    >
                        <FilterDialog
                            modalShow={() => undefined}
                            setFilterBallActive={() => undefined}
                        />
                    </ButtonToolbar>
                    <ButtonToolbar
                        icon={<MdEdit />}
                        label={t('custom_columns')}
                    >
                        <EditColumnsDialog
                            modalShow={() => undefined}
                            sonarView={viewSonar}
                        />
                    </ButtonToolbar>
                </div>
            </div>
        </NavbarWrapper>
    );
};

export default ToolbarPatientsSelector;